module.exports = __webpack_public_path__ + "static/ekstrabladet-bb58e6ffcf7738df6bc361e9cb850fe3.png";